let _ = require("underscore");
import i18n from "i18next";

let main = function () {
    return {
        msg: function (code, args) {
            let msg = "";

            if (_.isArray(args)) {
                msg = i18n.t(code);

                for (var i in args) {
                    msg = msg.replace("{" + i + "}", args[i]);
                }

                return msg;

            } else if (_.isString(args)) {
                msg = i18n.t(code);
                return msg != undefined ? msg.replace("{" + 0 + "}", args) : '';

            } else {
                msg = i18n.t(code);
                return msg == undefined ? '' : _.template(msg)(args == undefined ? {} : args);
            }
        },

        template: function (code) {
            var msg = i18n.t(code);
            return _.template(msg == undefined ? '' : msg);
        }
    };
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/utils/i18n.js